




















import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { WaiveServiceFeeReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class WaiveServiceFeeRewardEditor extends Vue {
  @Prop()
  value!:WaiveServiceFeeReward;

  workingReward:WaiveServiceFeeReward | null = null;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as WaiveServiceFeeReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
